/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
// import { TableFooter } from "components"
import React from 'react'

import { TableFooter } from 'components'
import { EditIcon, DeleteIcon } from 'components/Icons'
import { Entity } from 'services/NGT/Archives'
import { SPACING } from 'utils'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled
} from './TableActions.styles'

interface TableProps {
  listRow: Entity[]
  handleDelete: (id: any) => void
  handleUpdate: (id: any) => void
}

export const TableActions = (props: TableProps) => {
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(15)
  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled stickyHeader>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Centro</TableCellStyled>
              <TableCellStyled>Caixa Departamental</TableCellStyled>
              <TableCellStyled>Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? props.listRow.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : props.listRow
            ).map((row, index) => (
              <TableRowStyled
                key={`${row}-table-body`}
                evenNumber={index % 2 != 0}
              >
                <TableCellStyled>{row.descricaoCentroPlanta}</TableCellStyled>
                <TableCellStyled>{row.descricaoCaixa}</TableCellStyled>
                <TableCellStyled>
                  <EditIcon
                    onClick={() => props.handleUpdate(row)}
                    marginRight={SPACING.spacing15}
                  />
                  <DeleteIcon
                    cursor="pointer"
                    onClick={() =>
                      props.handleDelete(row.idParametrizacaoCaixa)
                    }
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        justifyContent={'left'}
        gridPercentage={'30'}
        rows={props.listRow}
        typeFooter="offline"
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
